<template>
  <u-animate-container v-wechat-title="$route.meta.title">
    <common-header @setLocale="getLocale"></common-header>
    <common-nav :locale="locale"></common-nav>
    <common-banner :locale="locale" title="contact"></common-banner>
    <div class="content">
      <div class="container">
        <div class="contact_three">
          <div class="contact_item">
            <div class="item_img">
              <img src="@/assets/images/icon_contact_mobile.png" alt="" />
            </div>
            <div class="item_txt">
              <span>{{ $t("contact.mobile") }}</span>
              <a href="tel:18033246966">18033246966</a>
            </div>
          </div>
          <div class="contact_item">
            <div class="item_img">
              <img src="@/assets/images/icon_contact_tel.png" alt="" />
            </div>
            <div class="item_txt">
              <span>{{ $t("contact.tel") }}</span>
              <a href="tel:075786602123">0757-86602123</a>
            </div>
          </div>
          <div class="contact_item">
            <div class="item_img">
              <img src="@/assets/images/icon_contact_email.png" alt="" />
            </div>
            <div class="item_txt">
              <span>{{ $t("contact.email") }}</span>
              <a href="mailto:sales@sailuk-rivet.com">SALES@SAILUK-RIVET.COM</a>
            </div>
          </div>
        </div>

        <div class="contact_info">
          <form class="contact_submit">
            <input
              type="text"
              class="ipt1 ipt_top"
              v-model.trim="name"
              :placeholder="$t('contact.form.name')"
            />
            <input
              type="text"
              class="ipt1 ipt_top"
              v-model.trim.number="tel"
              :placeholder="$t('contact.form.tel')"
            />
            <input
              type="text"
              class="ipt1"
              v-model.trim="email"
              placeholder="E-MAIL *"
            />
            <input
              type="text"
              class="ipt1"
              v-model.trim="title"
              :placeholder="$t('contact.form.title')"
            />
            <input
              type="text"
              class="ipt2"
              v-model.trim="content"
              :placeholder="$t('contact.form.content')"
            />
            <div class="btn_wrap">
              <div class="btn_submit" @click="post_form">
                {{ $t("contact.send") }}
              </div>
            </div>
          </form>
          <div class="contact_map">
            <a
              target="_blank"
              href="https://map.baidu.com/poi/西河五金制品有限公司/@12574888,2620470,13z?uid=c304c69fb1d13873750269ca&primaryUid=11920689533610016237&ugc_type=3&ugc_ver=1&device_ratio=1&compat=1&querytype=detailConInfo&da_src=shareurl"
              id="baidu_map"
            >
              <img
                src="@/assets/images/contact_map.png"
                alt="西河五金制品有限公司"
              />
            </a>
          </div>
        </div>
      </div>
    </div>
    <common-footer :locale="locale"></common-footer>
  </u-animate-container>
</template>
<script>
import { UAnimateContainer, UAnimate } from "vue-wow";
// import BMap from 'BMap'
import CommonHeader from "./components/Common/Header";
import CommonNav from "./components/Common/OtherNav";
import CommonBanner from "./components/Common/Banner";
import CommonFooter from "./components/Common/Footer";
export default {
  components: {
    CommonHeader,
    CommonNav,
    CommonBanner,
    CommonFooter,
    UAnimateContainer,
    UAnimate
  },
  data() {
    return {
      name: "",
      tel: "",
      email: "",
      title: "",
      content: "",
      locale: "zh-cn"
    };
  },
  watch: {
    locale(a, b) {}
  },
  mounted() {},
  created() {
    this.locale = window.localStorage.getItem("lang")
      ? window.localStorage.getItem("lang")
      : "zh-cn";
  },
  methods: {
    getLocale(e) {
      this.locale = e;
    },
    getTarget() {
      return this.$el;
    },
    post_form(e) {
      let _name = this.name;
      let _tel = this.tel;
      let _email = this.email;
      let _title = this.title;
      let _content = this.content;
      if (
        _name === "" ||
        _tel === "" ||
        _email === "" ||
        _title === "" ||
        _content === ""
      ) {
        this.$alert("请填写完整信息以方便我们能联系到您！");
      } else {
        this.$axios
          .post(
            "/api/contact/contact",
            {
              contactData: {
                username: _name,
                mobile: _tel,
                email: _email,
                title: _title,
                content: _content
              }
            },
            {
              headers: {
                token: "application"
              }
            }
          )
          .then(res => {
            console.log(res);
            if (res.data.errorCode === 0) {
              this.$alert("信息已提交！我们会尽快与您联系！");
            } else {
              this.$alert(res.data.errorMsg);
            }
          });
      }
    },
    empty_input(e) {
      console.log(e.target.value);
    }
  }
};
</script>

<style scoped lang="scss">
.content {
  background: #fafafa;
  box-sizing: border-box;
  padding: 60px 0;
  .container {
    width: 1140px;
    height: auto;
    margin-left: auto;
    margin-right: auto;
    .contact_three {
      background: #fff;
      border: 1px solid #fb8001;
      box-sizing: border-box;
      height: auto;
      overflow: hidden;
      .contact_item {
        width: 33%;
        padding: 0 30px;
        height: 2.4rem;
        padding-top: 0.3rem;
        border-right: 1px solid #fb8001;
        float: left;
        box-sizing: border-box;
        &:last-child {
          border-right: 0;
        }
        img {
          margin-left: auto;
          margin-right: auto;
          display: block;
          width: auto;
          height: 1rem;
        }
        .item_txt {
          color: #fb8001;
          font-size: 0.2rem;
          margin-top: 25px;
          text-align: center;
          line-height: 1.3;
          a {
            color: #fb8001;
            text-decoration: none;
          }
        }
      }
    }
    .contact_info {
      height: auto;
      overflow: hidden;
      box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
      box-sizing: border-box;
      background: #fff;
      margin-top: 60px;
      position: relative;
      .contact_submit {
        width: 720px;
        float: left;
        padding: 45px 80px;
        box-sizing: border-box;
        input {
          width: 260px;
          background: none;
          border: 0;
          outline: none;
          border-bottom: 1px solid #b7b7b7;
          color: #b7b7b7;
          transition: all 0.45s;
          font-size: 0.2rem;
          margin-bottom: 0.25rem;
          float: left;
          padding: 0.2rem 0;
          &.ipt1 {
            margin-right: 40px;
            margin-bottom: 1rem;
            &.ipt_top {
              margin-bottom: 0.35rem;
            }
            &:nth-of-type(2n) {
              margin-right: 0;
            }
          }
          &.ipt2 {
            width: 100%;
            margin-bottom: 0.4rem;
          }
          &.on {
            color: #333;
            border-color: #fb8001;
          }
          &:focus {
            color: #333;
            border-color: #fb8001;
          }
        }
        .btn_wrap {
          width: 100%;
          float: left;
          .btn_submit {
            width: 80px;
            padding: 18px 30px;
            font-size: 16px;
            color: #fb8001;
            display: block;
            margin-left: auto;
            margin-right: auto;
            border: 4px solid #fb8001;
            text-align: center;
            border-radius: 40px;
          }
        }
      }
      .contact_map {
        width: 420px;
        height: 100%;
        background: #eee;
        position: absolute;
        right: 0;
        top: 0;
        #baidu_map {
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
          display: block;
          img {
            object-fit: cover;
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 750px) {
  .content {
    padding: 15px 0;
    background: #fff;
    .container {
      width: 100%;
      box-sizing: border-box;
      .contact_three {
        border: 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        .contact_item {
          padding: 0;
          display: flex;
          flex-direction: row;
          width: 75%;
          border: 1px solid #fb8001;
          border-bottom: 0;
          height: 120px;
          &:last-child {
            border: 1px solid #fb8001;
          }
          .item_img {
            width: 30%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            img {
              height: 55px;
            }
          }
          .item_txt {
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            font-size: 0.7rem;
            margin-top: 0;
            text-align: left;
            span {
              &:first-child {
                font-weight: bold;
                margin-bottom: 10px;
              }
            }
          }
        }
      }
      .contact_info {
        margin-top: 30px;
        border-radius: 6px;
        display: flex;
        flex-direction: column-reverse;
        .contact_submit {
          margin: 0 15px;
          width: auto;
          padding: 0;
          input.ipt1,
          input.ipt2 {
            margin-right: 0;
            box-sizing: border-box;
            padding: 0.8rem 5px;
            width: 100%;
            font-size: 0.8rem;
            margin-bottom: 0;
            &.ipt_top {
              margin-bottom: 0;
            }
          }
          .btn_wrap {
            margin: 20px 0;
            .btn_submit {
              font-size: 0.8rem;
              width: 6rem;
              padding: 0;
              text-align: center;
              height: 2rem;
              line-height: 2rem;
              border-width: 2px;
              cursor: pointer;
            }
          }
        }
        .contact_map {
          width: 100%;
          position: relative;
          float: left;
          height: 300px;
          #baidu_map {
            position: relative;
            width: 100%;
            height: 300px;
            display: block;
            img {
              width: 100%;
              height: auto;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Contact.vue